export default __webpack_public_path__ + "static/media/not-connected-image.b942e12d.svg";